import { createSlice } from '@reduxjs/toolkit';
import { initialFundDetailsState as initialState } from './state';
import { fundDetailsReducer } from './reducers';

export const fundDetailsSlice = createSlice({
  name: 'fundDetails',
  initialState,
  reducers: {
    ...fundDetailsReducer,
  },
});

export const fundDetailsActions = fundDetailsSlice.actions;
